// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1S9AV","header":"ClearentDisclaimer_header__2EA-Q","inner":"ClearentDisclaimer_inner__2UkxY"};